// These columns are using the flex layout which is set where they are consumed,
// therefore the width option below specifies the flex-basis not the width in pixels
export const createColumnDefinitionBuilder =
  ({ header: defaultHeader, accessor: defaultAccessor, cell: defaultCell, width: defaultWidth, className: defaultClassName }) =>
  ({ header, accessor, cell, width, className } = {}) => {
    return {
      header: header || defaultHeader,
      accessor: accessor || defaultAccessor,
      cell: cell || defaultCell,
      width: width || defaultWidth,
      className: className || defaultClassName,
    };
  };
